// extracted by mini-css-extract-plugin
export default {"custom-field":"CustomCell_custom-field__O7wFy","custom-NUMERIC":"CustomCell_custom-NUMERIC__4R1tj"};